import { axios } from '@/utils/request'

const api = {
  scoreLogList: '/adminapi/score/scoreLogList',
  scoreEdit: '/adminapi/score/scoreEdit', 
}

export default api

 
export function scoreLogList(parameter) {
  return axios({
    url: api.scoreLogList,
    method: 'get',
    params: parameter
  })
}

export function scoreEdit(parameter) {
  return axios({
    url: api.scoreEdit,
    method: 'post',
    data: parameter
  })
}